import { useDriverCredentials } from '@api/useDriverCredentials'
import { UploadDownloadButtons } from '@components/_SiteWide/UploadStatus/UploadDownloadButtons'
import { GraviGrid, Vertical } from '@gravitate-js/excalibrr'
import type { AgGridReactProps } from 'ag-grid-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useMemo, useRef, useState } from 'react'

import { getColumnDefs } from './columnDefs'
import { gridViewManager } from '@/utils/grid'

const STORAGE_KEY = 'driver-credentials'

export function DriverCredentials({ title, updateSetting, handleCredentialLink }) {
  const [rowData, setRowData] = useState([])
  const gridAPIRef = useRef(null)
  const { getDriverCredentialsOverviewQuery, editDriverCredentialMutation } = useDriverCredentials()
  const { data, isFetching } = getDriverCredentialsOverviewQuery()
  const columnDefs = useMemo(() => getColumnDefs(handleCredentialLink), [data])
  const getRowId = (row) => row.data?.key

  const agPropOverrides: AgGridReactProps = useMemo(
    () => ({
      groupDefaultExpanded: -1,
      groupDisplayType: 'multipleColumns',
      autoGroupColumnDef: { minWidth: 200 },
      suppressAggFuncInHeader: true,
      getRowId,
    }),
    []
  )
  const handleSave = async (editedData) => {
    const request = {
      certification_date: moment(editedData.certification_date).format('YYYY-MM-DDT00:00:00'),
      credential_id: editedData.credential_id,
      driver_id: editedData.driver_id,
    }
    await editDriverCredentialMutation.mutateAsync(request)
  }

  const excelDownloadOptions = useMemo(
    () => ({
      sheetName: 'Driver Credentials',
      fileName: 'Driver Credentials.xlsx',
      allColumns: true,
    }),
    []
  )
  useEffect(() => {
    if (window.location.search.includes('key') && gridAPIRef.current) {
      const key = queryString.parse(window.location.search)?.key
      setRowData(data?.filter((row) => row.key === key))
    } else {
      setRowData(data)
    }
  }, [data])

  return (
    <GraviGrid
      primaryKey='key'
      externalRef={gridAPIRef}
      rowData={rowData || []}
      controlBarProps={{
        title,
        actionButtons: (
          // @ts-ignore: TODO: Make props optional on UploadDownloadButtons
          <UploadDownloadButtons
            excelOptions={[
              {
                title: 'Download Driver Credentials',
                onClick: () => gridAPIRef.current.exportDataAsExcel(excelDownloadOptions),
              },
            ]}
          />
        ),
      }}
      loading={isFetching}
      columnDefs={columnDefs}
      agPropOverrides={agPropOverrides}
      updateEP={handleSave}
      storageKey={STORAGE_KEY}
      onGridConfigChanged={(config) => updateSetting(`gridConfig::${STORAGE_KEY}`, config)}
      {...gridViewManager(STORAGE_KEY, updateSetting)}
    />
  )
}
